import { AbstractControl } from '@angular/forms';

export function PasswordPolicyValidator(control: AbstractControl): { [key: string]: boolean } | null {
    if (control.errors && !control.errors.passwordPolicy) {
        // return if another validator has already found an error on the matchingControl
        return null;
    }

    const regex = /^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[!\"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~])(.{16,1024})$/;
    if (control.value && !control.value.match(regex)) {
        return { 'passwordPolicy': true };
    } else {
        return null;
    }
}
